<footer class="main-footer no-print">
  <strong>Copyright &copy; 2014-2025 <a href="https://adminlte.io">AdminLTE.io</a>.</strong>
  All rights reserved.Version {{version_app}}-rc
  <div class="float-right d-none d-sm-inline-block">
    last update {{date_update | adtob}} <b> itBRD TEAM DEV </b>
  </div>
</footer>